import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BotComponent } from './components/bot/bot.component';
import { CodeValidationComponent } from './components/code-validation/code-validation.component';
import { ConfimationPagePlatformComponent } from './components/confimation-page-platform/confimation-page-platform.component';
import { ConfirmationPageComponent } from './components/confirmation-page/confirmation-page.component';
import { BusquedaComponent } from './components/search/busqueda.component';
import { StepperLtoComponent } from './components/stepper-lto/stepper-lto.component';
import { StepperComponent } from './components/stepper/stepper.component';

import { UrlSegment, UrlMatchResult } from '@angular/router';
import { ltoRedirectGuard } from './guards/lto-redirect.guard';

export function legacyRedirectMatcher(url: UrlSegment[]): UrlMatchResult | null {
  // Detects 'mx/solicitud' o 'mx/solicitud/bienvenida'.
  if (
    (url.length === 2 && url[0].path === 'mx' && url[1].path === 'solicitud') ||
    (url.length === 3 && url[0].path === 'mx' && url[1].path === 'solicitud' && url[2].path === 'bienvenida')
  ) {
    return { consumed: url };
  }
  return null;
}

const routes: Routes = [
  { path: 'solicitud', component: StepperComponent },
  { path: 'mx/solicitud/form/bienvenida', component: StepperLtoComponent },
  { path: 'mx/solicitud/form/bienvenida/from-legacy', component: StepperLtoComponent },
  { path: 'mx/solicitud/form/carga-documentos', component: StepperLtoComponent },
  { path: ':country/solicitud', component: StepperComponent },
  { path: ':country/solicitud/:current-step', component: StepperComponent, canActivate: [ltoRedirectGuard] },
  { path: ':country/:authorization/solicitud', component: StepperComponent },
  { matcher: legacyRedirectMatcher, redirectTo: 'mx/solicitud/form/bienvenida/from-legacy', pathMatch: 'full' },
  { path: 'busqueda/truora-token/:truoraToken', component: BusquedaComponent },
  { path: 'busqueda', component: BusquedaComponent },
  { path: 'bot', component: BotComponent },
  { path: 'confirmacion', component: ConfirmationPageComponent },
  {
    path: 'verificacion-codigo',
    component: CodeValidationComponent,
  },
  {
    path: 'verificacion-email',
    component: CodeValidationComponent,
  },
  {
    path: 'confirmacion-solicitud',
    redirectTo: 'mx/solicitud/form/carga-documentos'
    //component: ConfimationPagePlatformComponent,
  },
  {
    path: 'confirmacion-solicitud-2',
    component: ConfimationPagePlatformComponent,
  },
  { path: '**', redirectTo: 'busqueda' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
